import React from "react";
import "./Features.css";
import calendario from "../../assets/calendario.svg";
import ducha from "../../assets/ducha.svg";
import pesa from "../../assets/pesa.svg";
import salud from "../../assets/salud.svg";
import edu from "../../images/education_scholarship.jpg";

const Features = () => {
  return (
    <section id="features" className="container m-3 center">
      <h2 className="m-3">Our Features</h2>
      <div className="features">
        <div className="feature">
          <img className="feature__img" src={calendario} alt="TssClub events" />
          <h4>TRAINING</h4>
        </div>
        <div className="feature">
          <img
            className="feature__img"
            src={edu}
            alt="Education Scholarship"
          />
          <h4>SCHOLARSHIP</h4>
        </div>
        <div className="feature">
          <img className="feature__img" src={pesa} alt="TssClub Equipment" />
          <h4>GYM / FITNESS</h4>
        </div>
        <div className="feature">
          <img
            className="feature__img"
            src={salud}
            alt="Health Benefits"
          />
          <h4>HEALTH BENEFITS</h4>
        </div>
      </div>
    </section>
  );
};

export default Features;
